import Ripples from "react-ripples";
import {
  IconController,
  ImgController,
} from "../../../../../Scripts/ImgController";
import styled from "styled-components";
import { useContract } from "../../../../../../provider/ContractProvider";
import axios from "axios";
import { distributionUrl } from "../../../../../Config/url";
import { useAxiosConfigGlobal } from "../../../../../Config/axios";
import assets from "../../../../../../assets/assets";
import { useEffect, useState } from "react";
import ActionButtons from "../ActionButtons";
import TextInput from "../TextInput";

const BankInformation = () => {
  const axiosConfig = useAxiosConfigGlobal();
  const { data, setData, handleNext, handlePrevious } = useContract();

  const [formErrors, setFormErrors] = useState({});

  const [selectedBank, setSelectedBank] = useState({
    name: data.bank_account.bank.name,
    id: data.bank_account.bank.id,
    icon: data.bank_account.bank.icon,
  });
  const [bankChoose, setBankChoose] = useState(false);
  const [banks, setBanks] = useState([]);

  const selectBankHandler = (bank) => {
    setSelectedBank({
      name: bank.name,
      id: bank.id,
      icon: bank.cover,
    });
    setData((prevData) => ({
      ...prevData,
      bank_account: {
        ...prevData.bank_account,
        bank_id: bank.id,
        bank: {
          name: bank.name,
          id: bank.id,
          icon: bank.cover,
        },
      },
    }));

    setBankChoose(false);
  };

  const fetchBanks = () => {
    axios
      .get(distributionUrl + "panel-api/oauth/banks", axiosConfig)
      .then((res) => {
        setBanks(res.data.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          console.error(err);
        }
      });
  };

  useEffect(() => {
    fetchBanks();
  }, []);

  const banksMap = banks.map((bank) => (
    <div
      key={bank.id}
      className={`h-14 flex items-center gap-3 p-3 border rounded-xl cursor-pointer transition-all hover:border-mmusic ${
        selectedBank.id === bank.id
          ? "border-mmusic bg-blue-50"
          : "border-transparent"
      }`}
      onClick={() => selectBankHandler(bank)}
    >
      <div className="flex items-center gap-3">
        <ImgController src={bank.cover} className="w-6 h-6" />
        <span className="text-sm font-medium">{bank.name}</span>
      </div>
      <div className="ml-auto">
        <div
          className={`w-4 h-4 rounded-full flex items-center justify-center ${
            selectedBank.id === bank.id
              ? "bg-mmusic"
              : "border border-[#E4E7EC]"
          }`}
        >
          {selectedBank.id === bank.id && (
            <div className="w-1.5 h-1.5 bg-white rounded-full" />
          )}
        </div>
      </div>
    </div>
  ));

  const isFormValid =
    data.bank_account &&
    data.bank_account.bank?.id &&
    data.bank_account.name &&
    data.bank_account.number;

  const validateForm = () => {
    const errors = {};

    if (!data?.bank_account) {
      errors["bank_account.bank.id"] = "Банкаа сонгож өгнө үү";
    }
    if (!data?.bank_account?.bank?.id) {
      errors["bank_account.bank.id"] = "Банкаа сонгож өгнө үү";
    }

    if (!data?.bank_account?.name) {
      errors["bank_account.name"] = "Данс эзэмшигчийн нэрийг оруулна уу";
    }

    if (!data?.bank_account?.number) {
      errors["bank_account.number"] = "Дансны дугаарaa оруулна уу";
    }

    if (Object.keys(errors).length === 0) {
      setFormErrors({}); // ✅ Дата зөв байвал алдаануудыг арилгах
      return true;
    }
    setFormErrors(errors); // ❌ Алдаатай бол алдааг хадгалах
    return false;
  };

  useEffect(() => {
    if (data?.bank_account) {
      setFormErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };

        if (data.bank_account.bank?.id) {
          delete updatedErrors["bank_account.bank.id"];
        }
        if (data.bank_account.name) {
          delete updatedErrors["bank_account.name"];
        }
        if (data.bank_account.number) {
          delete updatedErrors["bank_account.number"];
        }

        return updatedErrors;
      });
    }
  }, [data.bank_account]); // 🔄 `bank_account` өөрчлөгдөх бүрт алдаа арилгах

  const onSubmit = () => {
    if (validateForm()) {
      handleNext();
    } else {
      return;
    }
  };

  const handleInputChange = (name) => (e) => {
    setData((prevData) => ({
      ...prevData,
      bank_account: {
        ...prevData.bank_account,
        [name]: e.target.value,
      },
    }));
  };

  return (
    <>
      <Wrapper>
        <div>
          <div className="flex flex-col gap-6 p-6">
            <div className="w-full relative">
              <h5 className="paragraph-CK">Банк сонгоно уу</h5>
              <Ripples
                color="#FFFFFF40"
                during={600}
                className="rounded-lg w-full mt-1.5 cursor-pointer"
              >
                <div
                  className="flex justify-between border border-[#d1d5db] p-3 w-full rounded-lg"
                  onClick={() => setBankChoose(true)}
                >
                  <div className="flex items-center gap-3">
                    {selectedBank.icon && (
                      <ImgController
                        src={selectedBank.icon}
                        className="w-6 h-6"
                      />
                    )}
                    <h5 className="font-normal text-[#667085] text-base">
                      {selectedBank.name || "Банкаа сонгож өгнө үү"}
                    </h5>
                  </div>
                  <IconController src={assets.svg.chevronDownBlue} />
                </div>
              </Ripples>
              {formErrors["bank_account.bank.id"] && (
                <p className="text-red-500 text-xs mt-1">
                  {formErrors["bank_account.bank.id"]}
                </p>
              )}

              {bankChoose && (
                <>
                  <Overlay onClick={() => setBankChoose(false)} />
                  <PopupStyled>
                    <div className="modal">
                      <div className="grid grid-cols-2 gap-4">{banksMap}</div>
                    </div>
                  </PopupStyled>
                </>
              )}
            </div>

            <div className="w-full">
              <TextInput
                type="number"
                label="Дансны дугаар*"
                name="number"
                placeholder="Жишээ нь: 8000051029"
                value={data.bank_account.number ?? ""}
                onChange={handleInputChange("number")}
                error={formErrors["bank_account.number"]}
              />
            </div>

            <div className="w-full">
              <TextInput
                type="text"
                label="Данс эзэмшигчийн нэр*"
                name="name"
                placeholder="Жишээ нь: Munkhgerel"
                value={data.bank_account.name ?? ""}
                onChange={handleInputChange("name")}
                error={formErrors["bank_account.name"]}
              />
              {formErrors["bank_account.name"] ? (
                ""
              ) : (
                <p className="italic font-normal text-[12px] text-[#697D95] mt-1">
                  Санамж: Гэрээ байгуулсан эзэмшигчийн нэр дээрх дансны дугаар
                  байх шаардлагатай.
                </p>
              )}
            </div>
          </div>
        </div>
      </Wrapper>

      <ActionButtons
        handlePrevious={handlePrevious}
        onSubmit={onSubmit}
        isFormValid={isFormValid}
        previousLabel="Буцах"
        submitLabel="Үргэлжлүүлэх"
      />
    </>
  );
};

const Wrapper = styled.div`
  .border-bottom {
    border-bottom: 1px solid #e4e7ec;
    padding-bottom: 24px;
  }

  .paragraph-CK {
    color: #344054;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    flex-basis: 30%;
  }

  .bank-selection {
    width: 100%;
    border: 1px solid #d1d5db;
    border: 0.5rem;
    padding: 12px 10px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    gap: 4px;
  }

  input {
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    padding: 10px 14px;
    font-size: 14px;
    width: 100%;
  }

  input[type="number"] {
    appearance: textfield;
    -moz-appearance: textfield;
    padding: 10px 14px;
    font-size: 14px;
    font-weight: 500;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .input-default {
    border: 1px solid rgba(208, 213, 221, 1);
    border-radius: 8px;
  }

  .input-error {
    border: 1px solid #f44336;
    border-radius: 8px;
  }

  .input-radius {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  .text-input {
    position: relative;
    height: 100%;
  }
`;

const PopupStyled = styled.div`
  position: absolute;
  bottom: 0;
  top: 76.5px;
  width: 100%;
  z-index: 103 !important;

  .modal {
    width: 100%;
    max-height: 292px;
    background: #ffffff;
    border: 2px solid #d0d5dd;
    box-shadow: 0px 20px 25px -5px rgba(0, 0, 0, 0.1),
      0px 10px 10px -5px rgba(0, 0, 0, 0.04);
    border-radius: 12px;
    padding: 16px;
    overflow-y: scroll;
  }

  .modal::-webkit-scrollbar {
    width: 0 !important;
    display: none !important;
  }
`;

const Overlay = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 102 !important;
  top: 0;
  left: 0;
`;

export default BankInformation;
